const TO_RADIANS = Math.PI / 180;
const CANVAS_AREA_LIMIT = 16777216;

/**
 * Create canvas preview
 * @param {object} image
 * @param {object} canvas
 * @param {object} crop
 * @param {object} cropPercent
 * @param {number|null} rotate
 */
export async function canvasPreview(
  image,
  canvas,
  crop,
  cropPercent,
  rotate = 0
) {
  const ctx = canvas.getContext("2d");

  if (!ctx) {
    throw new Error("No 2d context");
  }

  const pixelRatio = window.devicePixelRatio;

  let width = image.naturalWidth;
  let height = image.naturalHeight;

  const canvasSize = getDownScaleImageSize(
    {
      width: Math.floor(crop.width * pixelRatio),
      height: Math.floor(crop.height * pixelRatio),
    },
    CANVAS_AREA_LIMIT
  );

  canvas.width = canvasSize.width;
  canvas.height = canvasSize.height;

  ctx.scale(pixelRatio, pixelRatio);
  ctx.imageSmoothingQuality = "high";

  const cropX = Math.floor((width * cropPercent.x) / 100);
  const cropY = Math.floor((height * cropPercent.y) / 100);

  const rotateRads = rotate * TO_RADIANS;

  ctx.save();
  ctx.rotate(rotateRads);

  let shiftX = cropX;
  let shiftY = cropY;
  if (rotate === 0 || rotate === 180) {
    shiftX = rotate === 180 ? -cropX : cropX;
    shiftY = rotate === 180 ? -cropY : cropY;

    if (rotate === 180) {
      ctx.translate(-width, -height);
    }
  } else if (rotate === 90 || rotate === 270) {
    ctx.translate(rotate === 90 ? 0 : -width, rotate === 90 ? -height : 0);
    shiftX = ((width * cropPercent.y) / 100) * (rotate === 90 ? 1 : -1);
    shiftY = ((-height * cropPercent.x) / 100) * (rotate === 90 ? 1 : -1);
  }

  ctx.drawImage(
    image,
    shiftX,
    shiftY,
    width * cropPercent.height,
    height * cropPercent.width,
    0,
    0,
    width * cropPercent.height,
    height * cropPercent.width
  );

  ctx.restore();
}

/**
 * Get down scale image size
 * @param {object} size
 * @param {number} maximumPixels
 * @returns {object}
 */
function getDownScaleImageSize(size, maximumPixels) {
  const { width, height } = size;

  const requiredPixels = width * height;
  if (requiredPixels <= maximumPixels) return { width, height };

  const scalar = Math.sqrt(maximumPixels) / Math.sqrt(requiredPixels);
  return {
    width: Math.floor(width * scalar),
    height: Math.floor(height * scalar),
  };
}
